module.exports = __webpack_public_path__ + "static/media/1d5e0f80-7069-4312-94b1-1f0e777b68ab.9bbec6cf.jpg";